import { render, staticRenderFns } from "./DialogProposition.vue?vue&type=template&id=361def6e"
import script from "./DialogProposition.vue?vue&type=script&lang=js"
export * from "./DialogProposition.vue?vue&type=script&lang=js"
import style0 from "./DialogProposition.vue?vue&type=style&index=0&id=361def6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-load_1436e08e1734ba7ba526d61ea1cb1a74/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports